import { darken, transparentize } from 'polished';
import styled, { css } from 'styled-components';

import { returnCardStatisticColor } from '../../utils/returnCardStatisticColor';
/* eslint-disable no-nested-ternary */

interface ITimeLineCard {
  DFTIPOITEMCOLETA?: 'N' | 'C' | 'S';
  DFTIPOREGISTRO?:
    | 'N'
    | 'A'
    | 'D'
    | 'F'
    | 'C'
    | 'G'
    | 'Q'
    | 'R'
    | 'T'
    | 'O'
    | 'P'
    | '1'
    | '2';
}

export const ContainerStatisticsTimeLine = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1rem;
  overflow: auto;
  @media (max-width: 400px) {
    ::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: 600px) {
    align-items: center;
    justify-content: center;
  }
`;

export const TimeLineCard = styled.div<ITimeLineCard>`
  min-width: 200px;
  max-width: 400px;
  background-color: ${({ theme }) => darken(0.05, theme.COLORS.WHITE)};
  /* background-color: white; */
  /* -webkit-box-shadow: 0px 0px 14px 4px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0px 0px 14px 4px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 0px 14px 4px rgba(0, 0, 0, 0.08); */

  border-radius: 0 0.2rem 0.2rem 0;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  margin-left: 1rem;
  transition: 0.3s all;
  cursor: pointer;
  &:hover {
    margin-left: 2rem;
  }

  @media (max-width: 750px) {
    min-width: 300px;
    max-width: 400px;
  }
  @media (max-width: 600px) {
    min-width: 250px;
    max-width: 350px;
  }
  ${({ DFTIPOITEMCOLETA, DFTIPOREGISTRO }) => css`
    border-right: 4px solid
      ${returnCardStatisticColor({
        DFTIPOITEMCOLETA,
        DFTIPOREGISTRO,
      })};
    .icon {
      background-color: ${returnCardStatisticColor({
        DFTIPOITEMCOLETA,
        DFTIPOREGISTRO,
      })};
    }
  `}

  .icon {
    min-width: 50px;
    min-height: 50px;
    border-radius: 30px;
    right: 2rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .card-column {
    display: flex;
    flex-direction: column;
    padding: 1rem 1rem 1rem 0rem;
    span {
      font-size: 0.8rem;
    }
    span:first-child {
      font-weight: bold;
      font-size: 1.2rem;
      ${({ DFTIPOITEMCOLETA, DFTIPOREGISTRO }) => css`
        color: ${returnCardStatisticColor({
          DFTIPOITEMCOLETA,
          DFTIPOREGISTRO,
        })};
      `}
    }
  }
`;

export const TimeLineSpaceContainer = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: center; */
`;

export const CardOdometerContaner = styled.div`
  transition: 0.3s all;
  margin-top: 1rem;
  width: 200px;
  height: 200px;
  img {
    width: 200px;
    height: 200px;
  }
  cursor: pointer;
  &:hover {
    margin-left: 2rem;
  }
`;

export const TimeLineCurrentTime = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 1rem 0 1rem 0;
  padding: 1rem;
  background-color: ${({ theme }) => darken(0.1, theme.COLORS.WHITE)};
  min-height: 40px;
  border-radius: 0 0.2rem 0.2rem 0;
  border-right: 4px solid ${({ theme }) => darken(0.6, theme.COLORS.WHITE)};
  span {
    color: black;
  }
  transition: 0.3s all;
  cursor: pointer;
  &:hover {
    margin-left: 1rem;
  }
`;

export const TimeLineSpace = styled.div`
  min-height: 50px;
  width: 3px;
  margin: 1rem 1rem 1rem 2rem;
  background-color: ${({ theme }) => theme.COLORS.GREY};
`;

interface IMouthContainer {
  isDescarga?: boolean;
}

export const MouthContainer = styled.div<IMouthContainer>`
  margin-top: 8px;
  ${({ isDescarga }) =>
    isDescarga &&
    css`
      padding: 8px;
      background: #f9f9f9;
      border-radius: 4px;
    `}
`;

export const MouthHeader = styled.p`
  margin-bottom: 4px;
`;

export const MouthDischargeItem = styled.div`
  margin-left: 12px;
  margin-bottom: 8px;
  border-left: 2px solid #007bff;
  padding-left: 8px;
`;

export const MouthTemperature = styled.p`
  font-size: 13px;
  color: #555;
`;

export const MouthCollectionItem = styled.p`
  margin-left: 12px;
`;

export const ViewPhotosRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.6rem;
`;

export const ViewPhotosButton = styled.button`
  align-self: flex-start;
  border: 1px solid ${({ theme }) => theme.COLORS.GREEN_30};
  background-color: transparent;
  color: ${({ theme }) => theme.COLORS.GREEN_30};
  padding: 0.3rem 0.8rem;
  border-radius: 0.45rem;
  font-size: 0.75rem;
  font-weight: bold;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.GREEN_30};
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;

export const PhotosCountLabel = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => transparentize(0.3, theme.COLORS.GREY)};
`;
